export const ChannelAbout = ({ channel, text }) => {
  if (!text) return null;
  return (
    <section
      data-testid="channel-about"
      aria-labelledby="channel-about-heading"
      className="px-6 md:px-10"
    >
      <div className="max-w-3xl border-l-2 border-[#FF2A2A] pl-6 py-2">
        <h2 id="channel-about-heading" className="font-display text-2xl uppercase tracking-tight text-white/90">
          About {channel.name}
        </h2>
        <p data-testid="channel-about-text" className="mt-3 text-sm md:text-base text-zinc-400 leading-relaxed whitespace-pre-line">
          {text}
        </p>
      </div>
    </section>
  );
};
